// extracted by mini-css-extract-plugin
module.exports = {"option":"OptionSelect_option__3xlb8","dadosPlano":"OptionSelect_dadosPlano__3BbPz","focado":"OptionSelect_focado__27QXd"};